import api from './api';
import { ActiveAdBanner, AdBannerKind, AdBannerSetting, AdBannerStatsResponse } from '@radevents/shared';

export type { ActiveAdBanner, AdBannerKind, AdBannerSetting, AdBannerStatsResponse };

/** Anzeigen, die gerade laufen, mit ihrer Art. Öffentlich, eine Minute gecacht. */
export async function getActiveAdBanners(): Promise<ActiveAdBanner[]> {
  const res = await api.get('/public/ad-banners/active');
  return res.data;
}

export async function listAdBanners(): Promise<AdBannerSetting[]> {
  const res = await api.get('/admin/ad-banners');
  return res.data;
}

export async function setAdBannerActive(key: string, active: boolean): Promise<AdBannerSetting> {
  const res = await api.put(`/admin/ad-banners/${encodeURIComponent(key)}`, { active });
  return res.data;
}

/** Ankündigung (über den Events) oder Werbung (zwischen den Events). */
export async function setAdBannerKind(key: string, kind: AdBannerKind): Promise<AdBannerSetting> {
  const res = await api.put(`/admin/ad-banners/${encodeURIComponent(key)}`, { kind });
  return res.data;
}

/** Einblendungen und Klicks je Anzeige für 30, 90 oder 180 Tage. */
export async function getAdBannerStats(days: number): Promise<AdBannerStatsResponse> {
  const res = await api.get('/admin/ad-banners/stats', { params: { days } });
  return res.data;
}
